(() => {
if (window.gdcBound) return;
window.gdcBound = true;
document.querySelectorAll('[data-gdc-announcements]').forEach(bar => {
const slides = [...bar.querySelectorAll('[data-announcement-slide]')].filter(slide => slide.textContent.trim());
let index = 0;
const paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
const show = next => { index = (next + slides.length) % slides.length; slides.forEach((slide, i) => { slide.hidden = i !== index; }); };
bar.querySelector('[data-announcement-prev]').addEventListener('click', () => show(index - 1));
bar.querySelector('[data-announcement-next]').addEventListener('click', () => show(index + 1));
if (slides.length > 1) setInterval(() => { if (!paused && !document.hidden && !bar.matches(':hover') && !bar.contains(document.activeElement)) show(index + 1); }, 5000);
});
document.addEventListener('click', event => {
const target = event.target;
const dialog = document.getElementById('gdc-search-dialog');
if (target.closest('[data-gdc-search]') && dialog) dialog.showModal();
if (target.closest('[data-gdc-close]') && dialog) dialog.close();
if (target === dialog) {
const box = dialog.getBoundingClientRect();
if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
}
for (const menu of document.querySelectorAll('.gdc-shop-menu[open],.gdc-mobile-menu[open]')) {
if (!menu.contains(target) || target.closest('a')) menu.open = false;
}
if (target.closest('a[href="#gdc-story-more"]')) {
const story = document.getElementById('gdc-story-more');
if (story) story.open = true;
}
});
document.addEventListener('keydown', event => {
if (event.key === 'Escape') for (const menu of document.querySelectorAll('.gdc-shop-menu[open],.gdc-mobile-menu[open]')) menu.open = false;
});
})();

